import { getCadinuProfileAddress, getCadinuReferralAddress, getPancakeBunniesAddress } from 'utils/addressHelpers'

export const nftsBaseUrl = '/nfts'
export const pancakeBunniesAddress = getPancakeBunniesAddress()
// export const cadinuCIAsAddress = getCadinuCIAsAddress()
export const cadinuProfileAddress = getCadinuProfileAddress()
export const cadinuReferralAddress = getCadinuReferralAddress()
